import { MediaMatcher } from '@angular/cdk/layout';
import { Component, HostListener, ViewChild, OnInit } from '@angular/core';
import { MAT_AUTOCOMPLETE_DEFAULT_OPTIONS } from '@angular/material/autocomplete';

import { MatSidenav } from '@angular/material/sidenav';
import { NavigationEnd, Router } from '@angular/router';

import { AppConstant } from '@app/app.constants';
import { AuthService } from '@app/components/authentication/services/auth.service';
import { filter } from 'rxjs';

@Component({
  selector: 'app-private-layout',
  templateUrl: './private-layout.component.html',
  styleUrls: ['./private-layout.component.scss'],
  providers: [
    AppConstant,
    {
      provide: MAT_AUTOCOMPLETE_DEFAULT_OPTIONS,
      useValue: { overlayPanelClass: 'light-theme' }
    }
  ]
})
export class PrivateLayoutComponent implements OnInit {
  @ViewChild('sidenav') sidenav: MatSidenav | null = null;

  sidenavOpened = false;

  mobileQuery: MediaQueryList = this.mediaMatch.matchMedia(this.appConstant?.mobileResolution);

  showElementsNoLandingPage: boolean = true;
  @HostListener('window:resize')
  onResize() {
    this.mobileQuery = this.mediaMatch.matchMedia(this.appConstant?.mobileResolution);
  }

  get isSidenavOpened() {
    return this.sidenavOpened ? this.mobileQuery.matches : false;
  }

  constructor(public authService: AuthService, private mediaMatch: MediaMatcher, private appConstant: AppConstant, private router: Router) {}

  ngOnInit(): void {
    this.checkElementForLayout();
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
      this.checkElementForLayout();
    });
  }

  onToggleSidenav(sidenavOpened: boolean): void {
    this.sidenavOpened = sidenavOpened;
  }

  signOut() {
    this.sidenavOpened = false;
    this.authService.signOut().subscribe(res => {
      this.router.navigate(['/auth/signin']);
    });
  }

  goToProfileSettings() {
    this.sidenavOpened = false;
    this.router.navigate(['/profile']);
  }

  checkElementForLayout() {
    let contains = this.router.url.includes('/landing-page');
    !contains ? (this.showElementsNoLandingPage = true) : (this.showElementsNoLandingPage = false);
  }
}
